/** @module */

const DEBUGGING = true

/**
 * Assert that a condition is true.
 *
 * @param {boolean} condition
 * @param {string} message
 *
 * @throws {Error} If the condition is false
 */
export function assert (condition, message) {
  if (!condition) {
    throw new Error(message)
  }
}

/**
 * Sleep for a number of milliseconds.
 *
 * @param {number} ms
 * @returns <Promise.<void>>
 */
export async function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function debug (...args) {
  if (DEBUGGING) console.log(...args)
}

export function isInt (val) {
  return /^-?\d+$/.test(val.toString())
}

export function isFloat (val) {
  return /^-?\d+(?:\.\d+)?$/.test(val.toString())
}
